<template>
  <div></div>
</template>

<script>
export default {
  name: 'elConfigListSwitchItem'
}
</script>

<style></style>
